module.exports = __webpack_public_path__ + "img/text-01.2e96ce6d.png";